import React, {Component} from 'react';
import {Grid, Header, Form, Divider, Icon} from 'semantic-ui-react';
import {
  TextBoxField,
  InlineSelect,
  RadioField,
} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import OrgUsersCard from './orgUsersCard';
import OrgUserFormContainer from './orgUserFormContainer';
import _ from 'lodash';
import REST from 'go/requests/rest';
import {mapValuesToBody} from './utils';
import {toStartCase} from 'common/utils';
import PermissionsUtility from 'go/security/permissionsUtility';

const MODAL = {
  NONE: 'none',
};
const EMPTY_FILTER = [{key: '', value: null, text: ''}];

export class OrgUsersCardContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      addModalVisible: false,
      removeModalVisible: false,
      showRolesModalVisible: false,
      showRemoveConfirmation: false,
      userData: [],
      originalUserData: [],
      entities: [],
      filters: {
        teamMemberName: null,
        roleSelection: null,
        programSelection: null,
      },
      filterOptions: {},
      sortRadio: 'asc',
      searchTeamName: '',
      sortSelection: '',
      roleSelection: '',
      sortOptions: {sortBy: 'lastName', sortDir: 'asc'},
      roles: [],
      programs: [],
      assignedPrograms: [],
      successModal: false,
      showUserName: false,
      emailExistInFemmaGo: false,
      openModal: MODAL.NONE,
      subOrgToggle: false,
      loginGovIntegrationToggle: false,
      parentOrgs: [],
      parentOrgIdList: [],
    };
  }

  getSubOrgPrograms = async (token, parentOrgId, selectedOrgId) => {
    return REST.organizationRelationship.getSubOrgProgramsByParentOrgIdAndSubOrgId(
      token,
      parentOrgId,
      selectedOrgId
    );
  };

  createFilterOptions = (userData, programs) => {
    let filterOptions = {
      roles: _.clone(EMPTY_FILTER),
      programs: _.clone(EMPTY_FILTER),
    };

    let roleListCode = [];
    let programIds = [];
    _.map(userData, (member) => {
      if (member.roles) {
        _.map(member.roles, (role) => {
          if (roleListCode.indexOf(role.code) == -1) {
            filterOptions.roles.push({
              key: toStartCase(role.description),
              value: role.code,
              text: role.description,
            });
            roleListCode.push(role.code);
          }
          if (role.programs && !_.isEmpty(role.programs)) {
            _.each(role.programs, (prg) => {
              programIds.push(prg.programId);

              _.each(prg.programRoles, (role) => {
                filterOptions.roles.push({
                  key: toStartCase(role.description),
                  value: role.code,
                  text: role.description,
                });
              });
            });
          } else {
            _.each(programs, (prg) => {
              filterOptions.programs.push({
                key: prg.programId,
                value: prg.programId,
                text: prg.programName,
                programId: prg.programId,
              });
            });
          }
        });
      }
    });
    if (programIds.length === 0) {
      return;
    }
    programIds = new Set(programIds);
    let params = Array.from(programIds).toString();
    if (!params) {
      params = Array.from(this.state.programsArray).toString();
    }
    return REST.program
      .getProgramDetails(this.props.token, params)
      .then(REST.handler.handleResponse)
      .then((res) => {
        let userPrograms = res;
        _.each(userPrograms, (prg) => {
          filterOptions.programs.push({
            key: prg.programId,
            value: prg.programId,
            text: prg.programName,
            programId: prg.programId,
          });
        });

        filterOptions.roles = _.orderBy(filterOptions.roles, ['text'], ['asc']);
        filterOptions.programs = _.orderBy(filterOptions.programs, ['text'], ['asc']);

        _.each(_.keys(filterOptions), (key) => {
          filterOptions[key] = _.unionBy(filterOptions[key], 'key');
        });

        this.setState((prevState) => ({
          ...prevState,
          assignedPrograms: userPrograms,
          programs: programs,
          filterOptions: filterOptions,
        }));
      })
      .catch((err) => {
        console.error('error');
      });
  };

  reloadData = async () => {
    const {token, selectedOrgId, parentOrgId, parentuserEntities} = this.props;
    try {
      let res = await Promise.all([
        this.fetchOrgProfileData(token, selectedOrgId, parentOrgId, parentuserEntities),
        this.fetchRoleMapping(this.props.token),
        this.fetchEntities(this.props.token),
        this.getSubOrgPrograms(
          this.props.token,
          this.props.parentOrgId,
          this.props.selectedOrgId
        ),
      ]);
      const payload = await res;
      let userData = await payload[0].json();
      let mapping = await payload[1].json();
      let entities = await payload[2].json();
      let subProgramsApiRes = await payload[3];
      let subOrgPrograms;
      subOrgPrograms =
        subProgramsApiRes.status == 200 ? subProgramsApiRes.json() : undefined;
      let programsArray = [];
      if (subOrgPrograms) {
        _.map(subOrgPrograms.suborganizationPrograms, (program) => {
          programsArray.push(program.programId);
        });
      }
      this.setState({
        userData: userData,
        originalUserData: userData,
        programsArray: programsArray,
        mapping: mapping,
        entities: entities,
        loading: false,
        selectedUser: {
          userId: '',
          role: {
            description: '',
          },
        },
      });
      this.mapRoles(userData);
      this.fetchPrograms(
        token,
        selectedOrgId,
        parentOrgId,
        this.props.renderType,
        userData
      );
      this.fetchData();
      this.fetchParentOrgs(token, selectedOrgId);
      this.fetchSARPrograms(token, selectedOrgId, parentOrgId, userData);
    } catch (e) {
      console.error(e);
    }
  };
  async componentDidMount() {
    this.reloadData();
  }

  async componentDidUpdate(prevProps) {
    if (this.props.selectedOrgId != prevProps.selectedOrgId) {
      this.reloadData();
    }
  }

  fetchRoleMapping = async (token) => {
    return REST.user.getRoles(this.props.token);
  };

  displayNameParent = (parent, parentOrgs) => {
    const matchedParent = _.find(parentOrgs, {organizationId: parseInt(parent)});
    if (matchedParent) return matchedParent.displayName;
    else return parent;
  };

  fetchParentOrgs = async (token, selectedOrgId) => {
    const {parentOrgId} = this.props;
    REST.user
      .getParentEntities(token)
      .then(REST.handler.handleResponse)
      .then((res) => {
        if (res) {
          let ids = new Set(
            _.map(res, (result) => {
              return result.entityId;
            })
          );

          const orgId = [];
          if (ids.size == 0) {
            orgId.push(selectedOrgId);
          } else {
            _.each(Array.from(ids), (id) => orgId.push(id));
          }

          const organizations = [];
          if (!orgId.includes(parentOrgId)) {
            orgId.push(parentOrgId);
          }

          if (!orgId.includes(selectedOrgId)) {
            orgId.push(selectedOrgId);
          }
          return REST.organization
            .getOrganizationsListById(token, orgId)
            .then(REST.handler.handleResponse)
            .then((result) => {
              const resultdunsids = new Set(
                _.map(result, (resultduns) => {
                  const ueiPlusEft =
                    resultduns.uei +
                    (!_.isEmpty(_.trim(resultduns.eft))
                      ? '-' + _.trim(resultduns.eft)
                      : '');
                  const uei = resultduns.uei ? ` | UEI-EFT: ${ueiPlusEft}` : '';
                  const duns = resultduns.duns
                    ? ` | DUNS: ${resultduns.duns}`
                    : '' + resultduns.dunsPlus4
                    ? resultduns.dunsPlus4
                    : '';
                  return organizations.push({
                    displayName:
                      resultduns.displayName +
                      (_.includes(this.props.toggles, 'dunsToUEI') ? uei : '') +
                      duns,
                    organizationId: resultduns.organizationId,
                  });
                })
              );
              this.setState({parentOrgs: organizations});
            })
            .catch((err) => {
              console.error('error');
            });
        }
      })
      .catch((err) => {
        console.error('error');
      });
  };

  fetchPrograms = async (token, orgId, parentOrgId, renderType, userData) => {
    REST.organizationRelationship
      .getOrgPrograms(token, orgId, parentOrgId, renderType)
      .then(REST.handler.handleResponse)
      .then((res) => {
        const programs = res.organizationPrograms;
        let ids = new Set(
          _.map(programs, (program) => {
            return program.programId;
          })
        );

        // retreiving parentOrg is moved to fetchSARPrograms

        let params = Array.from(ids).toString();
        return REST.program
          .getProgramDetails(token, params)
          .then(REST.handler.handleResponse)
          .then((res) => {
            let programs = res;
            programs = _.orderBy(programs, ['programName'], ['asc']);
            this.setState(
              (prevState) => ({...prevState, programs: programs}),
              () => {
                this.createFilterOptions(userData, programs);
              }
            );
          })
          .catch((err) => {
            console.error('error');
            this.createFilterOptions(userData, []);
          });
      })
      .catch((err) => {
        console.error('error');
        this.createFilterOptions(userData, []);
      });
  };

  fetchSARPrograms = async (token, orgId, parentOrgId, userData) => {
    REST.organizationRelationship
      .getOrgSARPrograms(token, orgId, parentOrgId)
      .then(REST.handler.handleResponse)
      .then((res) => {
        const programs = res.organizationPrograms;

        let ids = new Set(
          _.map(programs, (program) => {
            return program.programId;
          })
        );

        let parentIdList = [];
        let uniqueParentorgId = null;

        _.forEach(programs, (obj) => {
          _.forEach(_.values(obj['parentOrganizations']), (obj) => {
            parentIdList.push(obj.organizationId);
          });
        });
        const canHaveSubOrganizations = _.chain(this.props.userEntities)
          .filter((y) => {
            return y.entityId === orgId;
          })
          .map((x) => {
            return x.canHaveSuborganizations;
          })
          .first()
          .value();

        if (
          parentIdList.isEmpty ||
          (!parentIdList.includes(orgId) && canHaveSubOrganizations)
        ) {
          parentIdList.push(Number(orgId));
        }
        uniqueParentorgId = _.uniq(parentIdList);
        this.setState({parentOrgIdList: uniqueParentorgId});

        let params = Array.from(ids).toString();
        return REST.program
          .getProgramDetails(token, params)
          .then(REST.handler.handleResponse)
          .then((res) => {
            let programs = res;
            programs = _.orderBy(programs, ['programName'], ['asc']);
            this.setState(
              (prevState) => ({...prevState, programs: programs}),
              () => {
                this.createFilterOptions(userData, programs);
              }
            );
          })
          .catch((err) => {
            console.error('error');
            this.createFilterOptions(userData, []);
          });
      })
      .catch((err) => {
        console.error('error');
        this.createFilterOptions(userData, []);
      });
  };

  fetchOrgProfileData = async (token, selectedOrgId, parentOrgId, parentuserEntities) => {
    try {
      let pending = this.props.pending;
      let permissionData = new PermissionsUtility(token);

      const organizations = _.filter(this.props.userEntities, (y) => {
        return y.entityId === selectedOrgId;
      });
      const canHaveSubOrganizations =
        organizations.length > 0 && organizations[0].canHaveSuborganizations;

      let parentOrgsList = [];
      if (selectedOrgId != parentOrgId && canHaveSubOrganizations) {
        parentOrgsList.push(selectedOrgId);
        parentOrgsList.push(parentuserEntities);
      } else if (selectedOrgId != parentOrgId) {
        parentOrgsList.push(parentuserEntities);
      }
      if (parentOrgsList == '' || parentOrgsList === undefined) {
        parentOrgsList =
          permissionData.getParentOrgIdListForSubOrg(selectedOrgId) === undefined
            ? parentOrgId
            : permissionData.getParentOrgIdListForSubOrg(selectedOrgId);
      }

      let manageTeamOrgSubOrgToggle = _.includes(
        this.props.toggles,
        'manageTeamOrgSubOrg'
      );
      this.setState({subOrgToggle: manageTeamOrgSubOrgToggle});
      let userEmailTableToggle = _.includes(this.props.toggles, 'userEmailTable');
      let loginGovIntegrationToggle = _.includes(
        this.props.toggles,
        'loginGovIntegration'
      );
      this.setState({loginGovIntegrationToggle, userEmailTableToggle});
      let url = '';
      if (pending === true) {
        if (manageTeamOrgSubOrgToggle) {
          return REST.user.getEntityTeamList(token, {
            pending: true,
            parentEntityId: parentOrgsList,
            entityId: selectedOrgId,
          });
        } else {
          return REST.user.getTeamList(token, {pending: true});
        }
      } else {
        if (manageTeamOrgSubOrgToggle) {
          return REST.user.getEntityTeamList(token, {
            parentEntityId: parentOrgsList,
            entityId: selectedOrgId,
          });
        } else {
          return REST.user.getTeamList(token, {entityId: selectedOrgId});
        }
      }
    } catch (error) {
      console.log('Error in fetchOrgProfileData', error);
    }
  };

  fetchEntities = async (token) => {
    return REST.user.getManagedEntities(token);
  };

  removeSelectedRole = async (userId, entityTypeId) => {
    const {selectedOrgId, token, pending, parentOrgId, toggles} = this.props;
    let manageTeamOrgSubOrgToggle = _.includes(toggles, 'manageTeamOrgSubOrg');
    let url = '';
    let body = {
      userId: userId,
      entityTypeId: entityTypeId,
    };
    if (pending === true) {
      return REST.user.removeRole(token, body, {
        pending: true,
        parentEntityId: parentOrgId,
        entityId: selectedOrgId,
      });
    } else {
      if (manageTeamOrgSubOrgToggle) {
        return REST.user.removeRole(token, body, {
          parentEntityId: parentOrgId,
          entityId: selectedOrgId,
        });
      } else {
        return REST.user.removeRole(token, body, {entityId: selectedOrgId});
      }
    }
  };

  removeUnregisteredUser = async (selectedUser) => {
    const {token, selectedOrgId} = this.props;

    let body = mapValuesToBody({originalUser: selectedUser.roles}, selectedOrgId);
    return REST.user
      .modifyUserRoles(token, selectedUser.userId, body)
      .then(REST.handler.handleResponse)
      .catch((err) => {
        console.error('error');
      });
  };

  openRemoveModal = (user) => {
    this.setState({
      removeModalVisible: !this.state.removeModalVisible,
      selectedUser: user,
    });
  };

  toggleModal(action) {
    if (action === 'add') {
      this.setState({
        addModalVisible: !this.state.addModalVisible,
      });
    } else if (action === 'remove') {
      this.setState({
        removeModalVisible: !this.state.removeModalVisible,
      });
    } else if (action === 'showRoles') {
      this.setState({
        showRolesModalVisible: !this.state.showRolesModalVisible,
      });
    } else if (action === 'showConfirmation') {
      this.setState({
        showRemoveConfirmation: !this.state.showRemoveConfirmation,
      });
    } else if (action === 'displayMsg') {
      this.setState({
        successModal: !this.state.successModal,
      });
    } else if (action === 'emailExistInFemmaGo') {
      this.setState({
        emailExistInFemmaGo: true,
      });
    } else if (action === 'emailNOTExistInFemmaGo') {
      this.setState({
        emailExistInFemmaGo: false,
      });
    }
  }
  mapRoles = async (userData) => {
    try {
      let roleList = [];
      let matchRoleList = [
        {
          key: '',
          value: '',
          text: '',
        },
      ];
      let allRoles = _.map(userData, (member) => {
        let roles = member.roles;
        let match = false;
        if (roles != null) {
          _.map(roles, (role, index) => {
            if (role.code != null && roleList.indexOf(role.code) == -1) {
              roleList.push(role.code);
              matchRoleList.push(role);
              match = true;
            }
          });
        }
        if (match) return match;
      });
      let rolesMap = matchRoleList.map((role) => ({
        key: role.code,
        value: role.code,
        text: role.displayText,
      }));
      this.setState({
        roles: rolesMap,
      });
    } catch (e) {
      console.error(e);
    }
  };
  openManageTeamModal = (user) => {
    this.setState({
      manageModalVisible: !this.state.manageModalVisible,
      selectedUser: user,
    });
  };

  reloadUserList = async () => {
    this.setState({loading: true});
    try {
      this.fetchOrgProfileData(
        this.props.token,
        this.props.selectedOrgId,
        this.props.parentOrgId,
        this.props.parentuserEntities
      )
        .then((res) => {
          if (res) {
            return res.json();
          } else {
            Promise.resolve('Invalid response');
          }
        })
        .then((resJson) => {
          this.setState({
            userData: resJson,
            originalUserData: resJson,
            loading: false,
            selectedUser: {
              userId: '',
              role: {
                description: '',
              },
              roles: [],
            },
          });
          this.fetchData();
          this.mapRoles(this.state.userData);
        });
    } catch (e) {
      this.setState({
        loading: false,
      });
      console.error(e);
    }
  };

  setFilter = (name, value) => {
    let filters = _.get(this.state, 'filters', {});
    filters[name] = value;
    this.handleFilterChange(filters);
  };

  handleFilterChange = async (filters) => {
    try {
      this.setState({loading: false, filters});
      let newData = await this.fetchData();
      this.setState({
        loading: false,
        filters,
        userDate: newData,
      });
    } catch (e) {
      console.error('Failed to process fetchData');
    }
  };

  clearAllFilters = async () => {
    try {
      this.setState({
        filters: {
          teamMemberName: '',
          roleSelection: '',
          programSelection: '',
          sortRadio: 'asc',
          sortSelection: 'lastName',
        },
        sortOptions: {sortBy: 'lastName', sortDir: 'asc'},
      });
      await this.setState({userData: this.state.originalUserData});
      this.fetchData();
    } catch (e) {
      console.error(e);
    }
  };

  handleSortChange = (name, value) => {
    let sortOptions = _.get(this.state, 'sortOptions', {});
    sortOptions[name] = value;
    this.setState({loading: false, sortOptions});
    this.fetchData();
  };

  applySort = (teamMembers) => {
    const sortBy = _.get(this.state.sortOptions, 'sortBy', 'userId');
    const sortDir = _.get(this.state.sortOptions, 'sortDir', 'asc');
    return _.orderBy(
      teamMembers,
      [(user) => _.toLower(_.get(user, sortBy, ''))],
      [sortDir]
    );
  };

  fetchData = async () => {
    try {
      let userData = this.state.originalUserData;
      let searchName = this.state.filters.teamMemberName;
      let roleSelection = this.state.filters.roleSelection;
      let programSelection = this.state.filters.programSelection;
      let filteredUserData = _.clone(userData);

      // add emailAdr if missing
      filteredUserData = filteredUserData.map((member) => {
        return {
          ...member,
          emailAdr: member.emailAdr || member.userId,
        };
      });

      if (!_.isEmpty(searchName)) {
        filteredUserData = filteredUserData.filter((member) => {
          return (
            member.userName != null &&
            member.userName.toLowerCase().includes(searchName.toLowerCase())
          );
        });
      }

      if (!_.isEmpty(roleSelection)) {
        filteredUserData = filteredUserData.filter((member) => {
          let roles = member.roles;
          let match = false;
          if (roles != null) {
            _.map(roles, (role, index) => {
              if (role.code == roleSelection) {
                match = true;
              }
            });
          }
          return match;
        });
      }

      if (!_.isEmpty(programSelection)) {
        filteredUserData = filteredUserData.filter((member) => {
          let roles = member.roles;
          let match = false;
          if (roles != null) {
            _.each(roles, (role) => {
              if (role.programs && !_.isEmpty(role.programs)) {
                _.each(role.programs, (program) => {
                  if (_.isEqual(program.programId, Number(programSelection))) {
                    match = true;
                  }
                });
              } else {
                match = true;
              }
            });
          }
          return match;
        });
      }

      if (!_.isEmpty(filteredUserData)) {
        let sortedData = this.applySort(filteredUserData);
        this.setState({userData: sortedData});
      } else {
        this.setState({userData: filteredUserData});
      }
    } catch (e) {
      console.error(e);
    }
  };

  renderMemberInfo = (value) => {
    this.setState({openModal: value});
  };

  getUserData = (userId, data) => {
    this.setState({userId, ...data});
  };

  render() {
    const {
      filters,
      filterOptions,
      sortOptions,
      loading,
      parentOrgs,
      parentOrgIdList,
      programs,
    } = this.state;
    const sortReorder = _.includes(this.props.toggles, 'disasterSiteNav');
    return (
      <React.Fragment>
        <Grid>
          <Grid.Row>
            {this.props.activeItem === 'Manage my team' && sortReorder && (
              <Grid.Column computer={4}>
                <Form>
                  <Grid doubling stackable reversed="mobile" padded="vertically">
                    <Grid.Column width={10}>
                      <Header as="h3">Search</Header>
                    </Grid.Column>
                    <Grid.Column width={6} textAlign="right">
                      <Icon name="undo" color="blue" size="small" />
                      <a
                        id="clearSearch"
                        className="table-link"
                        onClick={this.clearAllFilters}
                      >
                        Clear
                      </a>
                    </Grid.Column>
                  </Grid>
                  <TextBoxField
                    key="teamMemberName"
                    title="Search by Team Member Name"
                    name="teamMemberName"
                    label="Search by Name"
                    id="teamMemberName"
                    value={filters.teamMemberName || ''}
                    handleChange={(e) => this.setFilter(e.target.name, e.target.value)}
                  />
                  <Divider />
                  <Header as="h3">Filter by</Header>
                  <InlineSelect
                    key="rolesSelect"
                    id="role"
                    label="Role"
                    labeled="true"
                    search
                    selection
                    title="Filter by member Role"
                    name="roleSelection"
                    value={filters.roleSelection || ''}
                    handleChange={(e) => this.setFilter(e.target.name, e.target.value)}
                    options={filterOptions.roles}
                  />
                  {_.includes(this.props.toggles, 'manageTeamOrgSubOrg') && (
                    <InlineSelect
                      key="programSelect"
                      id="program"
                      label="Grant program"
                      labeled="true"
                      search
                      selection
                      title="Filter by grant program"
                      name="programSelection"
                      value={filters.programSelection || ''}
                      handleChange={(e) => this.setFilter(e.target.name, e.target.value)}
                      options={filterOptions.programs}
                    />
                  )}
                  <Divider />
                  <Header as="h3">Sort</Header>
                  <InlineSelect
                    key="teamMemberSortBySelect"
                    search
                    selection
                    title="Sort"
                    name="sortBy"
                    id="sortBy"
                    label="Sort by"
                    value={sortOptions.sortBy}
                    handleChange={(e) => {
                      this.handleSortChange(e.target.name, e.target.value);
                    }}
                    options={[
                      {
                        key: 'lastName',
                        value: 'lastName',
                        text: 'Last Name',
                      },
                      this.state.loginGovIntegrationToggle
                        ? {
                            key: 'emailAdr',
                            value: 'emailAdr',
                            text: 'Email for notifications',
                          }
                        : {key: 'emailAdr', value: 'emailAdr', text: 'Email'},
                    ]}
                  />
                  <Form.Field>
                    <RadioField
                      key="grantSortDirRadio"
                      name="sortDir"
                      value={sortOptions.sortDir}
                      handleChange={(e) => {
                        this.handleSortChange(e.target.name, e.target.value);
                      }}
                      options={[
                        {label: 'Ascending (A-Z)', value: 'asc'},
                        {label: 'Descending (Z-A)', value: 'desc'},
                      ]}
                    />
                  </Form.Field>
                </Form>
              </Grid.Column>
            )}
            <Grid.Column mobile={16} computer={12} className="sam-info-card">
              <OrgUsersCard
                renderType={this.props.renderType}
                userData={this.state.userData}
                entities={this.state.entities}
                loading={this.state.loading}
                toggleModal={this.toggleModal.bind(this)}
                removeModalVisible={this.state.removeModalVisible}
                showRolesModalVisible={this.state.showRolesModalVisible}
                showRemoveConfirmation={this.state.showRemoveConfirmation}
                selectedUser={this.state.selectedUser}
                removeSelectedRole={this.removeSelectedRole}
                removeUnregisteredUser={this.removeUnregisteredUser}
                reloadUserList={this.reloadUserList.bind(this)}
                openRemoveModal={this.openRemoveModal.bind(this)}
                userId={this.props.userId}
                selectedOrgId={this.props.selectedOrgId}
                pending={this.props.pending}
                openManageTeamModal={this.openManageTeamModal.bind(this)}
                closeManageTeamModal={this.openManageTeamModal.bind(this)}
                manageModalVisible={this.state.manageModalVisible}
                programs={programs}
                assignedPrograms={this.state.assignedPrograms}
                subOrgToggle={this.state.subOrgToggle}
                loginGovIntegrationToggle={this.state.loginGovIntegrationToggle}
                displayNameParent={this.displayNameParent}
                parentOrgs={parentOrgs}
                parentOrgId={this.props.parentOrgId}
                orgs={parentOrgIdList}
              />
            </Grid.Column>
            {this.props.activeItem === 'Manage my team' && !sortReorder && (
              <Grid.Column computer={4}>
                <Form>
                  <Grid doubling stackable reversed="mobile" padded="vertically">
                    <Grid.Column width={10}>
                      <Header as="h3">Search</Header>
                    </Grid.Column>
                    <Grid.Column width={6} textAlign="right">
                      <Icon name="undo" color="blue" size="small" />
                      <a
                        id="clearSearch"
                        className="table-link"
                        onClick={this.clearAllFilters}
                      >
                        Clear
                      </a>
                    </Grid.Column>
                  </Grid>
                  <TextBoxField
                    key="teamMemberName"
                    title="Search by Team Member Name"
                    name="teamMemberName"
                    label="Search by Name"
                    id="teamMemberName"
                    value={filters.teamMemberName || ''}
                    handleChange={(e) => this.setFilter(e.target.name, e.target.value)}
                  />
                  <Divider />
                  <Header as="h3">Filter by</Header>
                  <InlineSelect
                    key="rolesSelect"
                    id="role"
                    label="Role"
                    labeled="true"
                    search
                    selection
                    title="Filter by member Role"
                    name="roleSelection"
                    value={filters.roleSelection || ''}
                    handleChange={(e) => this.setFilter(e.target.name, e.target.value)}
                    options={filterOptions.roles}
                  />
                  {_.includes(this.props.toggles, 'manageTeamOrgSubOrg') && (
                    <InlineSelect
                      key="programSelect"
                      id="program"
                      label="Grant program"
                      labeled="true"
                      search
                      selection
                      title="Filter by grant program"
                      name="programSelection"
                      value={filters.programSelection || ''}
                      handleChange={(e) => this.setFilter(e.target.name, e.target.value)}
                      options={filterOptions.programs}
                    />
                  )}
                  <Divider />
                  <Header as="h3">Sort</Header>
                  <InlineSelect
                    key="teamMemberSortBySelect"
                    search
                    selection
                    title="Sort"
                    name="sortBy"
                    id="sortBy"
                    label="Sort by"
                    value={sortOptions.sortBy}
                    handleChange={(e) => {
                      this.handleSortChange(e.target.name, e.target.value);
                    }}
                    options={[
                      {
                        key: 'lastName',
                        value: 'lastName',
                        text: 'Last Name',
                      },
                      this.state.loginGovIntegrationToggle
                        ? {
                            key: 'emailAdr',
                            value: 'emailAdr',
                            text: 'Email for notifications',
                          }
                        : {key: 'emailAdr', value: 'emailAdr', text: 'Email'},
                    ]}
                  />
                  <Form.Field>
                    <RadioField
                      key="grantSortDirRadio"
                      name="sortDir"
                      value={sortOptions.sortDir}
                      handleChange={(e) => {
                        this.handleSortChange(e.target.name, e.target.value);
                      }}
                      options={[
                        {label: 'Ascending (A-Z)', value: 'asc'},
                        {label: 'Descending (Z-A)', value: 'desc'},
                      ]}
                    />
                  </Form.Field>
                </Form>
              </Grid.Column>
            )}
          </Grid.Row>
        </Grid>
        <OrgUserFormContainer
          users={this.state.userData}
          entities={this.state.entities}
          mapping={this.state.mapping}
          editModalVisible={this.state.editModalVisible}
          addModalVisible={this.state.addModalVisible}
          toggleModal={this.toggleModal.bind(this)}
          reloadUserList={this.reloadUserList.bind(this)}
          token={this.props.token}
          successModal={this.state.successModal}
          emailExistInFemmaGo={this.state.emailExistInFemmaGo}
          profile={this.state.profile}
          selectedOrgId={this.props.selectedOrgId}
          renderMemberInfo={this.renderMemberInfo}
          openModal={this.state.openModal}
          getUserData={this.getUserData}
          memberInfo={this.state}
          subOrgToggle={this.state.subOrgToggle}
          userEmailTableToggle={this.state.userEmailTableToggle}
          loginGovIntegrationToggle={this.state.loginGovIntegrationToggle}
          renderType={this.props.renderType}
          isManuallyAdded={this.props.isManuallyAdded}
          parentOrgId={this.props.parentOrgId}
          orgData={this.props.orgData}
          parentOrgs={parentOrgs}
          displayNameParent={this.displayNameParent}
          orgs={parentOrgIdList}
          programs={programs}
        />
      </React.Fragment>
    );
  }
}

export default OrgUsersCardContainer;
